module.exports = __webpack_public_path__ + "static/media/doulanshan_web.07987fdf.webp";